import React from "react";
import "../../Components/Menu/Menu.css";

export default function Access() {
  return (
    <div>
      <h4 className="sub-title">
        Innsyn, retting og sletting av app og personopplysninger
      </h4>
      <p className="content">
        <p>
          Du kan få innsyn i opplysningene Bilista har registrert om deg ved å
          sende en henvendelse på e-post til{" "}
          <a className="mail-lab" href="mailto:hei@bilista.no">
            hei@bilista.no
          </a>
        </p>
        <p>
          Vi oppfordrer deg til å ta kontakt for å rette opplysninger om deg som
          ikke er korrekte.
        </p>
        <p>
          Du kan når som helst slette appen og brukerdataene som er lagret på
          mobiltelefonen din.
        </p>
        <p>
          I «Min profil» i appen kan du slette alle personopplysningene om deg i
          appens database. Alle opplysningene om deg blir slettet automatisk
          hvis du ikke har tatt i bruk appen de siste 24 månedene.{" "}
        </p>
        <p>
          Velger du å inngå et kundeforhold med noen av leverandørene i appen,
          er det til enhver tid leverandørenes vilkår som gjelder.
        </p>
      </p>
    </div>
  );
}
